import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import dynamic from "next/dynamic"
import Link from "next/link";
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { useTemplatePageContent } from "../Providers/TemplatePageContentContext";

const BoxContainer = dynamic(() => import("../Reusables/BoxContainerV2"));
const PageHead = dynamic(() => import("../Reusables/PageHead"));

const LandingPage = (props) => {
    const {
        template_page_settings,
        landing_page_data,
        pageData
    } = props;
    
    const {template_page_content, meta} = useTemplatePageContent();
	const page_content = template_page_content;

    return (
        <>
            <PageHead
                title={meta.meta_title}
                description={meta.meta_description}
            />
            <BoxContainer className="mt-4" template_page_settings={template_page_settings}>
                <Typography component="h1" variant="h1">{pageData.title}</Typography>
                <Typography className="mb-4" component="h5" variant="h5">{pageData.subtitle}:</Typography>

                <ul>
                    {landing_page_data.map((element, idx) => (
                        <li key={idx} className="mb-1">
                            <Link prefetch={false} href={`/${pageData.route}/${element.slug}`}>
                                <IconButton aria-label={element.slug} size="small">
                                    <ArrowCircleRightOutlinedIcon fontSize="small" />
                                </IconButton>
                                {element.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </BoxContainer>
        </>
    )
}

export default LandingPage